import moment from 'moment';


export const TEST_TIMEOUT = 30000;

export const API_DATE_FORMAT = 'YYYY-MM-DD';

export const CACHE = {
  defaultLayout: 'defaultLayout',
  expandedMenuItems: 'expandedMenuItems',
  expiry: 8, // in hours
  exportToken: 'exportToken',
  habuHelpDocsReturnToURL: 'habuHelpDocsReturnToURL',
  deepLinkSearch: 'deepLinkSearch',
  inboundInvitations: 'inboundInvitations',
  impersonation: {
    impersonator: 'impersonator',
    refreshToken: 'impersonatorsRefreshToken',
  },
  landingPage: 'landingPage',
  sessionId: 'sessionId',
  sideNavLayout: 'sideNavLayout',
  themeType: 'themeType',
  user: {
    jwtAccessToken: 'jwtAccessToken',
    jwtRefreshToken: 'jwtRefreshToken',
    id: 'id',
    primaryAccount: 'primaryAccount',
    primaryOrg: 'primaryOrg',
    userDetails: 'userDetails',
    isDemoAccount: 'isDemoAccount',
  },
};

export const cardsPerPageOptions = [30, 60, 100];

export const consentConstants = {
  jobLevel: 'Job Level',
  orgLevel: 'Organization Level',
};

export const DROPDOWN_NONE_VALUE = '-';

export const filterOptions = [
  {
    startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    title: 'Trailing 7 Days',
  },
  {
    startDate: moment().subtract(14, 'days').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    title: 'Trailing 14 Days',
  },
  {
    startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    title: 'Trailing 30 Days',
  },
];

export const ITEM_PER_PAGE_OPTIONS = [12, 24, 48, 96];

export const SORT_DIRECTION = {
  ASCENDING: 'ASCENDING',
  DESCENDING: 'DESCENDING',
};

export const habuSupport = {
  email: 'help@habu.com',
  message: 'Please contact us at help@habu.com if this persists',
};

export const orgTypes = {
  Standard: 'standard',
  SSO: 'sso',
};

export const PRODUCT = {
  POST_RUN_PROCESSING: {
    name: 'PostRunQueryProcessing',
    display_name: 'Post Run Query Processing',
    description: 'Post Run Query Processing feature toggle to enable for an organization',
  },
  DATA_CONNECTION: {
    name: 'Data Connection',
    displayName: 'Data Connection',
  },
  HABU_INTELLIGENCE_CLONING: {
    name: 'HICloning',
    displayName: 'Intelligence Cloning',
  },
};

// TODO: DV-10680, deprecate GPG Encryption but keep the code for now
// TODO: DV-10383 Deprecate OPJA feature but keep the code for now
// TODO: DV-11205 Deprecate Question Purpose feature but keep the code for now
export const productPerm = {
  alerts: 'Alerts',
  crAdmin: 'CleanRoomsAdmin',
  LiveCleanRoomAdmin: 'LCRAdmin',
  LCRDatasetManager: 'LCRDatasetManager',
  crPartnerReadOnly: 'CleanRoomsPartnerReadOnly',
  crReadOnly: 'CleanRoomsReadOnly',
  crQuestionPermissions: 'CleanRoomQuestionPermissions',
  cdp: 'CDP',
  dataConnectionFieldEncryption: 'DataConnectionFieldEncryption',
  dataInAdmin: 'DataInAdmin',
  dataInUseCases: 'DataInUseCases',
  dataOutAdmin: 'DataOutAdmin',
  dataOutReadOnly: 'DataOutReadOnly',
  ExternalAPIAccess: 'ExternalAPIAccess',
  HabuConfidentialComputing: 'HabuConfidentialComputing',
  habuIntelligenceAdmin: 'HabuIntelligenceAdmin',
  habuIntelligence: 'Habu Intelligence',
  questionBuilderAdmin: 'QuestionBuilderAdmin',
  userListAdmin: 'UserListAdmin',
  questionManagementAdmin: 'QuestionManagementAdmin',
  GPGEncryption: 'GPGEncryption',
  databricksSQLCleanroom: 'DatabricksSQLCleanroom',
  ActivationChannels: 'ActivationChannels',
  googlePAIR: 'PAIR',
  OPJA: 'OPJA',
  Snowpark: 'Snowpark',
  cleanRoomActivation: 'CleanRoomActivation',
  flowManagement: 'Flows Management',
  snowflakeResultShare: 'SnowflakeResultShare',
  DisableQuestionReportBuilder: 'DisableQuestionReportBuilder',
  QuestionBuilderV3: 'QuestionBuilder3.0',
  QuestionPurpose: 'QuestionPurpose',
  AIQueryHelper: 'AIQueryHelper',
  AIQuestionDescription: 'AIQuestionDescription',
  DifferentialPrivacy: 'DifferentialPrivacy',
  AIHabuAssistant: 'AIHabuAssistant',
  CapacityManagementSnowflakePattern: 'CapacityManagementSnowflakePattern',
  EncryptedListExport: 'EncryptedListExport',
  CleanRoomPermissionEnhancement: 'CleanRoomPermissionEnhancement',
  LiveRampActivation: 'LiveRampActivation',
  Transcoding: 'Transcoding',
  UserDefinedFunctionSupport: 'UserDefinedFunctionSupport',
  AMCListQuestion: 'AMCListQuestion',
  CleanComputeSpark: 'CleanComputeOnSparkQuestion',
  UserTrustCenterAdmin: 'UserTrustCenterAdmin',
  UserTrustCenterReadOnly: 'UserTrustCenterReadOnly',
  CrRunSummary: 'CleanRoomRunSummary',
  DatasetMaterialization: 'DatasetMaterialization',
  IdentityResolution: 'IdentityResolution',
  DisableIdentifierProjection: 'DisableIdentifierProjection',
  cleanRoomActivationV1: 'CleanRoomActivationV1',
  LegacyHabuActivationChannels: 'LegacyHabuActivationChannels',
  DecoupleFromTemplate: 'DecoupleFromTemplate',
  CapacityManagement: 'CapacityManagement',
  ExclusiveDatasetMode: 'ExclusiveDatasetMode',
  EnableCsvExport: 'EnableCsvExport',
  AIEnabledIdentifiertypeDropdown: 'AIEnabledIdentifiertypeDropdown',
  SnowflakeTranscoding: 'SnowflakeTranscoding',
  LiveCleanRoom: 'LiveCleanRoom',
  EnableArraySupport: 'EnableArraySupport',
  OnDemandExportSnowflake: 'OnDemandExportSnowflake',
  LegacyDataSourceLocation: 'LegacyDataSourceLocation',
  ExplainPlanReports: 'ExplainPlanReports',
  AiQueryOptimizations: 'AiQueryOptimizations',
  DataConnectionViews: 'DataConnectionViews',
  EnableCustomExportPath: 'EnableCustomExportPath',
  RemoveFieldDelimiters: 'RemoveFieldDelimiters',
  CleanComputeDockerContainers: 'CleanComputeDockerContainers',
  EnableCustomFileName: 'EnableCustomFileName',
  FieldDescription: 'FieldDescriptionLayer',
  IdentityResolutionEnhancements: 'IdentityResolutionEnhancements',
  QuestionVersioningEnhancement: 'QuestionVersioningEnhancement',
  InternationalIdentityResolution: 'InternationalIdentityResolution',
  FlowExports: 'FlowExports',
  FlowSegmentation: 'FlowSegmentation',
  UnpublishQuestion: 'UnpublishQuestion',
  CredentialsSupportForCsvCatalog: 'CredentialsSupportForCsvCatalog',
  RTPsValueConstraints: 'RTPsValueConstraints',
  EnableRelativeMonthsForScheduler: 'EnableRelativeMonthsForScheduler',
};

export const bigQueryCompatibility = {
  cleanRooms: ['AMC', 'FAA', 'ADH', 'Snowflake', 'Walled Green', 'Hybrid', 'HCC'],
  footNoteExtended: 'BigQuery Export is supported in Snowflake, Walled Green, Hybrid, and HCC Clean Rooms and S3 Export is supported in Snowflake & Walled Green Clean Rooms',
  alertExtended: 'BigQuery is compatible with AMC, FAA, ADH, Snowflake, Walled Green, Hybrid, and HCC Clean Rooms.',
};

export const cleanRoomPermissions = {
  viewReports: 'CR-ViewReports',
  manageReports: 'CR-ManageReports',
  scheduleRuns: 'CR-ScheduleRuns',
  cleanRoomManagement: 'CR-CleanRoomManagement',
  partnerManagement: 'CR-PartnerManagement',
  activation: 'CR-Activation',
  manageDatasets: 'CR-ManageDatasets',
  habuIntelligenceRead: 'CR-HabuIntelligenceRead',
  habuIntelligenceWrite: 'CR-HabuIntelligenceWrite',
  questionBuilder: 'CR-QuestionBuilder',
  manageQuestions: 'CR-ManageQuestions',
  viewUserLists: 'CR-ViewUserLists',
  manageUserLists: 'CR-ManageUserLists',
  crFlowsBuilder: 'CR-FlowsBuilder',
  crManageFlowRuns: 'CR-CreateDeleteFlowRuns',
  crViewOnlyFlows: 'CR-ViewFlows',
};

export const rowsPerPageOptions = [10, 30, 50];

export const sortDirections = { asc: 'asc', desc: 'desc' };

export const trademark = `©${(new Date()).getFullYear()} LiveRamp`;

export const UI_DATE_FORMAT = 'DD MMM. YYYY';

export const US_DATE_FORMAT = 'MM/DD/YYYY';

export const US_DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm A';

export const UI_DISPLAY_DATE_TIME_FORMAT = 'DD MMM. YYYY  hh:mm A';

export const UI_DATE_TIME_FORMAT = 'YYYY-MM-DDThh:mm';

export const SCHEDULE_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const TIMESTAMP_DATE_TIME_FORMAT = 'YYYY-MM-DD, hh:mm:ss A';

export const UI_TIMESTAMP_DATE_TIME_FORMAT = 'MM-DD-YYYY, hh:mm:ss A';

export const UI_SHORT_DATE = 'DD MMM';

export const userTypes = {
  accountAdmin: 'AccountAdmin',
  superuser: 'SuperUser',
  consoleUser: 'ConsoleUser',
};

// Keys used by Moonraker to find the path of documentation and redirect the user to it
export const HELP_DOC_PATH_MAP = {
  cleanRoomCustomization: 'clean_room_customization',
  cleanRoomInviteFlow: 'cr_partner_invite',
  cleanRoomNavGuide: 'crq_nav_guide',
  navigation: 'navigation',
  questionManagement: 'question_management',
  questionBuilder: 'question_builder',
  snowFlakeAccountInfo: 'sf_account_info',
  installDatabricksCli: 'install_databricks_cli',
};

export const DEFAULT_AUTO_REFRESH_INTERVAL = 30000; // 30 seconds

export const SESSION_STORAGE_KEYS = {
  // Below keys are used in Question Builder
  QB_CR_ID: 'QB_CR_ID',
  QB_CR_OWNERSHIP: 'QB_CR_OWNERSHIP',
  QB_CR_TYPE: 'QB_CR_TYPE',
};

export const fileUploadStatus = {
  success: 'success',
  mismatch: 'mismatch',
  uploading: 'uploading',
  error: 'error',
};

export const HABU_ENVIRONMENT = 'staging';

export const REDIRECT_ENABLED = 'false';

export const REDIRECT_URL = 'https://connect.dev.liveramp.com/login';

export const userPermissions = {
  dataImportJobsReadOnly: 'DataImportJobsReadOnly',
  dataImportJobsAdmin: 'DataImportJobsAdmin',
  userListReadOnly: 'UserListReadOnly',
  orgAdmin: 'OrgAdmin',
  habuManagedSnowflakeAccount: 'HabuManagedSnowflakeAccount',
  ...userTypes,
  ...productPerm,
  ...cleanRoomPermissions,
};

export const REPORT_LIMIT = 1000;

export const LEGIT_REDIRECT_URL = {
  'api.habu.com': 'api.habu.com',
  'api.habu-labs.com': 'api.habu-labs.com',
  'console.habu.com': 'console.habu.com',
  'console.habu-labs.com': 'console.habu-labs.com',
  'habu.zendesk.com': 'habu.zendesk.com',
};
